<div class="itinerary-passenger" *ngFor="let room of rooms">
  <span class="itinerary-icons"><em class="fas fa-bed"></em></span>
  <span class="itinerary-title d-none">{{ "ITINERARY.HOTEL.ROOM" | translate }} {{ room.reqdguaranteetype }}</span>
  <h6>
    <span class="text-capitalize">
      <span *ngIf="hotelHasMoreThanOneRoom()" class="itinerary-title--hide">
        {{ "ITINERARY.HOTEL.ROOM" | translate }}
        {{ room.reqdguaranteetype }}:
      </span>
      {{ room.room_description | lowercase }},
      {{ room.plan_description | lowercase }}
    </span>
  </h6>
  <h6>
      <div class="itinerary-icons">
        <em class="fas fa-users mr-1"></em>
      </div>
      <span>{{ getTotalGuests(room) }} {{ getTotalGuests(room) === 1 ? ('COMMON.PERSON_SINGULAR' | translate) : ('COMMON.PERSON_PLURAL' | translate) }}</span>

    <p style="padding-left: 25px;">
      <small *ngIf="room.additional_info" class="text-primary" [innerHTML]="room.additional_info | safeHtml"></small>
    </p>
    <ng-container *ngIf="room.status === 'onRequest'">
      <span class="badge badge-warning on-request-badge">
        {{ 'ITINERARY.ON-REQUEST' | translate }}
      </span>
    </ng-container> 
  </h6>
</div>
